import React, { FC } from 'react';

import Online from '@/components/online/Online';
import { Medium } from '@/constants/mediums';

const HeatOnlinePage: FC = () => {
  return <Online medium={Medium.heat} allowMinuteData={false} />;
};

export default HeatOnlinePage;
